import { EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from "../api.service";
import { CommonService } from '../common.service';
var FailComponent = (function () {
    function FailComponent(router, apiService, commonService) {
        this.router = router;
        this.apiService = apiService;
        this.commonService = commonService;
        this.onRestart = new EventEmitter();
        this.assetsRoute = "../../assets";
    }
    FailComponent.prototype.ngOnInit = function () {
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        var htmlFontSize = document.documentElement.clientWidth / 7.5;
        document.documentElement.style.fontSize = htmlFontSize + "px";
        document.documentElement.style.backgroundColor = "#3d3d6d";
    };
    FailComponent.prototype.ngAfterViewInit = function () {
    };
    FailComponent.prototype.restart = function () {
        this.onRestart.emit(true);
    };
    FailComponent.prototype.closeWindow = function () {
        var _this = this;
        var dnaReturnUrl = this.commonService.getStorage('dnaReturnUrl');
        if (dnaReturnUrl) {
            window.location.href = dnaReturnUrl;
            this.commonService.removeStorage('dnaReturnUrl');
        }
        else {
            if (this.survey.type == 1) {
                wx.closeWindow();
            }
            else {
                this.apiService.ajax({
                    'type': 'get',
                    'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId
                }).subscribe(function (result) {
                    var link = ['learning-path', result];
                    _this.router.navigate(link);
                });
            }
        }
    };
    return FailComponent;
}());
export { FailComponent };



// WEBPACK FOOTER //
// ./src/app/fail/fail.component.ts.pre-build-optimizer.js